import Back from '@@/core/components/shared/Back/Back';
import Form from '@@/core/libraries/form/Form'
export default {
  name: 'PostCreateEdit',
  components: {Back, Form},
  data() {
    return {
      data: {},
      axiosCancelSource: null,
      widgetData: {},
      createRules: {},
      editRules: {},
      mode: 'create',
      editModel: {}
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.url = 'admin/posts/' + this.$route.params.id
      this.mode = 'edit';
      this.getPost()
    } else {
      this.url = 'admin/posts'
      this.getRules()
    }
  },
  methods: {
    async getPost() {
      try {
        this.axiosCancelSource = this.$axios.CancelToken.source();
        const response = await this.$axios.get(this.url,
            {
              params: {widgets: '["post_categories"]'},
              cancelToken: this.axiosCancelSource.token
            });
        this.widgetData = response.data.data.widgets
        this.createRules = response.data.data.store_rules
        this.editRules = response.data.data.update_rules
        this.editModel = response.data.data.post
      } catch (error) {
        if (this.$axios.isCancel(error)) {
          return;
        }
        this.$root.notify(error)
      }
    },
    async getRules() {
      try {
        this.axiosCancelSource = this.$axios.CancelToken.source();
        const response = await this.$axios.get(this.url,
            {
              params: {widgets: '["post_categories"]'},
              cancelToken: this.axiosCancelSource.token
            });

        this.widgetData = response.data.data.widgets
        this.createRules = response.data.data.store_rules
        this.editRules = response.data.data.update_rules
      } catch (error) {
        if (this.$axios.isCancel(error)) {
          return;
        }
        this.$root.notify(error)
      }
    },
    back() {
      this.$refs.back.$el.click();
    }
  }
}
